import { z } from 'zod';
import { AiAdvanceValidationError } from '../../ai-platform/ports.js';
import { availabilitySlotSchema, availabilityStaffSchema } from '../../ai-platform/availability-platform.js';
export const CDLIT_AVAILABILITY_FORBIDDEN_BODY_FIELDS = [
    'serviceId',
    'serviceExternalId',
    'companyId',
    'bookingCompanyId',
    'locationId',
    'tenantKey',
    'productKey',
    'staffId',
    'date',
    'slotDate',
    'slotTime',
];
export const cdlitAvailabilityStaffListResponseSchema = z
    .object({
    staff: z.array(availabilityStaffSchema),
})
    .strict();
export const cdlitAvailabilitySlotsListResponseSchema = z
    .object({
    slots: z.array(availabilitySlotSchema),
})
    .strict();
export const cdlitAvailabilityDatesListResponseSchema = z
    .object({
    dates: z.array(z.string().regex(/^\d{4}-\d{2}-\d{2}$/)).max(14),
})
    .strict();
export const cdlitAvailabilitySelectStaffRequestSchema = z
    .object({
    staffExternalId: z.string().regex(/^\d{1,32}$/),
})
    .strict();
export const cdlitAvailabilitySelectSlotRequestSchema = z
    .object({
    startAt: z.string().datetime(),
})
    .strict();
export function assertNoForbiddenAvailabilityBodyFields(body) {
    if (body == null || typeof body !== 'object' || Array.isArray(body)) {
        return;
    }
    for (const key of Object.keys(body)) {
        if (CDLIT_AVAILABILITY_FORBIDDEN_BODY_FIELDS.includes(key)) {
            throw new AiAdvanceValidationError(`Forbidden field: ${key}`);
        }
    }
}
//# sourceMappingURL=availability.js.map